import { ShieldCheck } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangBanQuyen } from './pages/TrangBanQuyen.js';

const compliance: KhaiBaoModule = {
  id: 'compliance',
  nav: {
    group: 'QUẢN TRỊ',
    label: 'Bản quyền',
    icon: ShieldCheck,
    order: 2,
    permission: 'compliance',
    to: '/ban-quyen',
  },
  routes: [
    {
      path: '/ban-quyen',
      element: createElement(TrangBanQuyen),
      permission: { module: 'compliance', level: 'view' },
    },
  ],
};

export default compliance;
